import { SET_COLUMNS, SET_IS_RESIZING, SET_LEFTOVER_COLUMN_WIDTH, SET_RESET_TO_SCROLL_TOP } from './constants';

export const setColumns = (columns) => ({
  columns,
  type: SET_COLUMNS,
});

export const setIsResizing = (isResizing) => ({
  isResizing,
  type: SET_IS_RESIZING,
});

export const setLeftoverColumnWidth = (leftoverColumnWidth) => ({
  leftoverColumnWidth,
  type: SET_LEFTOVER_COLUMN_WIDTH,
});

export const setResetToScrollTop = (resetToScrollTop) => ({
  resetToScrollTop,
  type: SET_RESET_TO_SCROLL_TOP,
});
